import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './base-details.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var BaseDetails = _ref => {
  var Icon = _ref.icon,
    label = _ref.label,
    children = _ref.children,
    className = _ref.className;
  return ___EmotionJSX("div", {
    "data-testid": "item",
    css: /*#__PURE__*/_css([styles.item, className])
  }, Icon && ___EmotionJSX("div", {
    "data-testid": "itemIcon"
  }, ___EmotionJSX(Icon, {
    size: "small"
  })), ___EmotionJSX("div", {
    "data-testid": "itemLabel",
    css: styles.itemLabel(!!Icon)
  }, label, ":"), ___EmotionJSX("div", {
    "data-testid": "itemValue",
    css: styles.itemValue
  }, children));
};
BaseDetails.defaultProps = {
  icon: null,
  className: null
};
BaseDetails.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  icon: PropTypes.func,
  className: PropTypes.string
};
export default BaseDetails;